<router-outlet></router-outlet>
<app-loader></app-loader>
@if (!cookieService.cookieAsked) {
  <main id="cookie-banner" class="container-skyscraper">
    <div class="as-cookie-hint as-cookie-hint--fixed">
      <div class="as-content-wrapper as-page-content">
        <div class="row middle-sm">
          <div class="col-xs-12 col-sm-8 as-xs-mb-15 as-sm-mb-0">
            <h4>
              Der Schutz Ihrer Online-Daten hat f&uuml;r {{bankNameForCookie}} Priorit&auml;t.
            </h4>
            <p class="as-typography as-xs-mb-10">
              Unsere Website und ihre Partner möchten Cookies verwenden, um die Besucher und die Performance der Website zu messen.<br />
              Sie können Ihre Auswahl jederzeit widerrufen, indem Sie <span class="u-text-color-mute" id="cookieSpan">"Cookies-Einstellungen"</span> auf unserer Website aufrufen.
            </p>
            <input id="cookieSelect" name="cookieSelect" class="c-checkbox" type="checkbox"  [(ngModel)]="cookieEnabled"> Statistische Cookies
            <p class="as-typography as-typography--light as-xs-mb-10" style="font-size: smaller; ">
              Diese Cookies erm&ouml;glichen es uns, die Anzahl der Besucher und die Leistung der Website, den Inhalt und die Interaktionen der Nutzer zu messen.<br/>
              Auf diese Weise kann {{bankShortName}} Studien und Statistiken durchf&uuml;hren, um die Leistung der Website zu verbessern (z. B. die Benutzerfreundlichkeit zu erh&ouml;hen, nicht relevante Inhalte
              nicht mehr anzuzeigen usw.).<br/>
              F&uuml;r die Verwendung dieser Cookies ben&ouml;tigen wir Ihre ausdr&uuml;ckliche Einwilligung gem. Art. 6 Abs. 1 lit. a DSGVO.
            </p>
          </div>
          <div class="col-xs-12 col-sm-4 center-xs end-sm">
            <button class="c-btn" id="button.acceptCookies" (click)="enableCookie()">Statistische Cookies zulassen
            </button>
          </div>
          <br />
          <div class="col-xs-12 col-sm-4 center-xs end-sm">
            <a class="c-btn" id="button.rejectCookies" (click)="rejectCookie()">Cookies ablehnen</a>
          </div>
          <div class="col-xs-12 col-sm-4 center-xs end-sm">
            <span class="as-typography as-xs-mb-10" style="font-size: smaller;">Weitere Informationen auch zu Ihrem Widerrufsrecht finden Sie in unseren <a class="btn btn-link footer" style="padding-top: inherit;"
              target="_blank" id="privacy_link"
            [href]="privacyPageUrl">Datenschutzhinweisen</a>
            und der <a class="btn btn-link footer" style="padding-top: inherit;" target="_blank" id="more_info_cookies" [href]="cookiePageUrl">Cookie Richtlinie</a>.
          </span>
          <div style="font-size: smaller;">
            @if (brand == 'REN') {
              <a class="btn btn-link footer"
                target="_blank"
                id="impressum_ren"
              href="https://www.mobilize-fs.de/impressum">Impressum</a>
            }
            @if (brand == 'DAC') {
              <a class="btn btn-link footer"
                target="_blank"
                id="impressum_dac"
              href="https://www.mobilize-fs.de/impressum">Impressum</a>
            }
            @if (brand == 'NIS') {
              <a class="btn btn-link footer"
                target="_blank"
                id="impressum_nis"
              href="https://nissan-bank.de/rechtliche-hinweise/impressum">Impressum</a>
            }
            @if (brand == 'RCI') {
              <a class="btn btn-link footer"
                target="_blank"
                id="impressum_rci"
              href="https://www.rcibanque.de/meta/impressum">Impressum</a>
            }
          </div>
        </div>
        <div class="col-xs-12 col-sm-4 center-xs end-sm">
        </div>
      </div>
    </div>
  </div><!-- end as-cookie-hint -->
</main>
}

